import { Button, CloseButton, IconButton } from '@ui/shared/Button';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import {
  closeInnerPopup,
  innerPopup,
  openInnerPopup,
} from '../../../data/providers/popupsProvider';
import { IApiKey } from '../../../data/types';
import { deleteKey } from '../../../data/writers/apiKeys';
import { CardBody } from '../../shared/card/CardBody';
import {
  CardFooter,
  CardFooterLeft,
  CardFooterRight,
} from '../../shared/card/CardFooter';
import {
  CardHeader,
  CardHeaderLeft,
  CardHeaderRight,
} from '../../shared/card/CardHeader';
import { FormContainer } from '../../shared/form/FormContainer';
import { LinearLoading } from '../../shared/loading/LinearLoading';
import {
  InnerPopupCard,
  PopupCardContent,
} from '../../shared/popups/PopupCard';

interface IProps extends RouteComponentProps {
  apiKey: IApiKey;
}

/**
 * @description button that opens the delete api key popup
 * @param props
 */
export const DeleteKeyPopup = withRouter(
  (props: IProps): React.ReactElement => {
    /**
     * @description handles the opening of the popup
     */
    const openDialog = (): void =>
      openInnerPopup(
        <Popup
          onClose={closeInnerPopup(props.history)}
          apiKey={props.apiKey}
        />,
        props.history,
        'delete'
      );

    return (
      <IconButton
        icon='remove_circle'
        onClick={openDialog}
        title='Delete Key'
      />
    );
  }
);

interface IDeleteKeyPopupProps {
  onClose: () => void;
  apiKey: IApiKey;
}
/**
 * @description popup that allows user to delete an api key
 * @param props
 */
const Popup = (props: IDeleteKeyPopupProps): React.ReactElement => {
  const [isDeleting, setIsDeleting] = React.useState<boolean>(false);
  /**
   * @description performs the deletion of the api key
   */
  const deleteApiKey = (): void => {
    setIsDeleting(true);
    deleteKey(props.apiKey).then((): void => {
      setIsDeleting(false);
      innerPopup.next(null);
    });
  };
  return (
    <InnerPopupCard onClose={props.onClose} size='small' noClickOutside>
      <PopupCardContent>
        <CardHeader surface={8}>
          <CardHeaderLeft>
            <h5>Delete API Key</h5>
          </CardHeaderLeft>
          <CardHeaderRight>
            <CloseButton onClick={props.onClose} />
          </CardHeaderRight>
        </CardHeader>
        <CardBody>
          {isDeleting && <LinearLoading />}
          <FormContainer>
            Deleting this integration will cause any application currently using
            the associated key to lose access to your data.
          </FormContainer>
        </CardBody>
        <CardFooter surface={8}>
          <CardFooterLeft />
          <CardFooterRight>
            <Button onClick={deleteApiKey} type='submit' title='Delete Key' />
          </CardFooterRight>
        </CardFooter>
      </PopupCardContent>
    </InnerPopupCard>
  );
};
